import { FC } from "react";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Grid } from "@mui/material";
import { formatDuration } from "./helpers";
import styled from "styled-components/macro";
import { StyledTooltip } from "./StyledTooltip";
import { techList } from "./data/data";
import birkbeckImg from "./img/birkbeck.jpeg";
import { ProjectSubtitle, ProjectTitle } from "./StyledComponents";

const StyledSubContent = styled.div`
  margin-bottom: 20px;
  .company-name {
    font-size: 14px;
    padding-bottom: 8px;
    font-weight: 400;
    @media screen and (max-width: 1000px) {
      padding-bottom: 0px;
    }
  }
  .content {
    color: ${({ theme }) => theme.text};
    color: rgb(65, 65, 88);
    font-size: 16px;
    .title {
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      .date {
        text-align: right;
        font-size: 14px;
        font-weight: 300;
        @media screen and (max-width: 1000px) {
          display: none;
        }
      }
      .date-mobile {
        display: none;
        @media screen and (max-width: 1000px) {
          display: block;
          font-size: 12px;
          font-weight: 300;
        }
      }
    }
    ul {
      padding-inline-start: 20px;
    }

    div:first-child {
      font-size: 18px;
      padding-bottom: 0px;
      font-weight: 600;
    }

    font-weight: 300;
    padding-bottom: 12px;
  }
  a {
    color: #4ac6ff;
    font-weight: 600;
    align-items: center;
    display: flex;
  }
  a.github {
    display: inline-block;
    border: none;
  }
  .MuiSvgIcon-root {
    border-radius: 50%;
    margin-left: 16px;
    font-size: 16px;
    transition: all 0.5s ease-in-out;
  }

  .visit-project {
    float: right;
    border-bottom: none;
    font-weight: 300;
    :hover {
      text-decoration: underline;
    }
  }
  .experience-content {
    font-size: 14px;
    font-weight: 300;
    p {
      font-weight: 400;
      color: rgba(104, 121, 152, 1);
      margin: 0px;
    }

    li {
      color: rgb(65, 65, 88);
      margin-bottom: 10px;
      padding-bottom: 8px;
    }
  }
  @media screen and (max-width: 1000px) {
    margin-bottom: 20px;
    .content {
      font-size: 18px;
    }
  }
`;

const StyledGrid = styled(Grid)`
  && {
    @media screen and (max-width: 1000px) {
      width: 90vw;
      flex-basis: 100%;
      max-width: 100%;
    }
  }
`;

interface ExperienceContentType {
  contentData: {
    title: string;
    companyName: string;
    description: string;
    date?: string;
    img: string;
    url: string;
    tech?: string[];
    id?: string;
    category: string;
  };
}

export const ExperienceContent: FC<ExperienceContentType> = ({
  contentData,
}) => {
  return (
    <Grid container>
      <Grid item xs={2} className="company">
        <img
          src={contentData.id === "birkbeck" ? birkbeckImg : contentData.img}
          alt={"company"}
          height={80}
        />
      </Grid>
      <StyledGrid item xs={10}>
        <StyledSubContent>
          <div className={"content"}>
            <div className="title">
              <div>
                <ProjectTitle>
                  {contentData.title}
                  <ArrowOutwardIcon fontSize="small" />
                </ProjectTitle>
                <ProjectSubtitle>{contentData.companyName} </ProjectSubtitle>
                <div className="date-mobile">
                  {contentData.category === "job"
                    ? formatDuration(contentData.date!)
                    : contentData.date}
                </div>
              </div>
              <div className="date">{contentData.date}</div>
            </div>
            <div
              className="experience-content"
              dangerouslySetInnerHTML={{
                __html: contentData.description.replace(
                  /href=/g,
                  'rel="noreferrer" target="_blank" href='
                ),
              }}
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
              {contentData.tech?.map((tech: string) => {
                const techDetails = techList.find((t) => t.name === tech);
                return (
                  <svg width={40} height={30} key={tech}>
                    <StyledTooltip
                      title={techDetails?.name ?? ""}
                      aria-label={techDetails?.name}
                      placement="bottom"
                      arrow
                    >
                      <image
                        x={0}
                        y={0}
                        width={30}
                        height={30}
                        href={techDetails?.link}
                      />
                    </StyledTooltip>
                  </svg>
                );
              })}
            </div>
          </div>
        </StyledSubContent>
      </StyledGrid>
    </Grid>
  );
};
